import styled from "styled-components";

export const AaPlatformStyled = styled.div`
  padding: 0 10px;
  .input_wrap {
    margin-bottom: 24px;
  }
  .button_layout {
    padding: 0 42px;
    display: flex;
    justify-content: flex-end;
    column-gap: 37px;
    .button1 {
      flex-basis: 215px;
    }
    .button2 {
      flex-basis: 215px;
    }
  }
`;
